import useHttpMutation from 'data/firestore/useHttpMutation';

export default function useUpdateCustomer() {
    return useHttpMutation<unknown, { phoneNumber: string }>({
        method: 'PATCH',
        pathname: '/customers',
    });
}
